import React from 'react';
export { ProjectList } from './List';
export { ProjectDetails } from './Details';
export { ProjectSettings } from './Details/Settings';
export { ProjectAdd } from './Add';

export const Project: React.FC = () => {
    return null;
};
